import { callApi } from './ApiClient';

const postCorrect = (data, dispatch) => {
  return callApi('POST', `/letter-corrections/correct`, data, dispatch);
}

export const LetterCorrectionsApi = {
  postCorrect,
};



// WEBPACK FOOTER //
// ./src/redux/api/LetterCorrectionsApi.js